import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { ToastContainer } from "react-toastify";
import { AuthProvider } from "./providers/AuthContext";
import { EmailsProvider } from "./providers/EmailsContext";
import { BrowserRouter as Router } from "react-router-dom";
import { MeetingsProvider } from "./providers/MeetingsContext";

// Wrap app with error boundary for deeper React errors
class GlobalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error(
      "%c[REACT ERROR BOUNDARY CAUGHT ERROR]",
      "color:red;font-weight:bold"
    );
    console.error("Error:", error);
    console.error("Component Stack:", errorInfo.componentStack);

    this.setState({
      error,
      errorInfo,
    });

    // Log additional diagnostic info
    console.group("React Error Boundary - Additional Info");
    console.log("React Version:", React.version);
    console.log("Error occurred at:", new Date().toISOString());
    console.log("Current URL:", window.location.href);
    console.groupEnd();
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            margin: "20px",
            padding: "20px",
            border: "2px solid #ff0000",
            borderRadius: "5px",
            backgroundColor: "#fff0f0",
          }}
        >
          <h1>Something went wrong in the React application</h1>
          <p>
            <strong>Error:</strong>{" "}
            {this.state.error?.toString() || "Unknown error"}
          </p>
          <details style={{ marginTop: "20px" }}>
            <summary>Component Stack Trace</summary>
            <pre
              style={{
                backgroundColor: "#f8f9fa",
                padding: "15px",
                overflow: "auto",
                maxHeight: "300px",
                fontSize: "12px",
              }}
            >
              {this.state.errorInfo?.componentStack || "No stack available"}
            </pre>
          </details>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: "20px",
              padding: "10px 15px",
              backgroundColor: "#0066cc",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

// Initialize app with error boundary
ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Router basename="/">
      <AuthProvider>
        <EmailsProvider>
          <MeetingsProvider>
            <GlobalErrorBoundary>
              <ToastContainer position="top-right" autoClose={5000} />
              <App />
            </GlobalErrorBoundary>
          </MeetingsProvider>
        </EmailsProvider>
      </AuthProvider>
    </Router>
  </React.StrictMode>
);
